// extracted by mini-css-extract-plugin
export default {"container":"PathwayAlignmentSubmission_container__OZYBb"};